import {
  IgBasePrimitives,
  IgGreenPrimitives,
} from "@intelligems/ig-design-tokens";
import { IgChip } from "@intelligems/ig-theme";
import type { SxProps, Theme } from "@mui/material";

type GateChipTone = "module" | "savings";

const TONE_SX: Record<GateChipTone, SxProps<Theme>> = {
  module: {
    backgroundColor: IgBasePrimitives[50],
    color: IgBasePrimitives[500],
  },
  savings: {
    backgroundColor: IgGreenPrimitives[200],
    color: IgGreenPrimitives.A300,
  },
};

type GateChipProps = Readonly<{
  label: string;
  tone?: GateChipTone;
  sx?: SxProps<Theme>;
}>;

export const GateChip = ({ label, tone = "module", sx }: GateChipProps) => (
  <IgChip
    color="secondary"
    label={label}
    sx={[
      {
        border: "none",
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.5px",
        px: "10px",
        py: "4px",
        textTransform: "uppercase",
      },
      TONE_SX[tone],
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);
